import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AdminLogin from "./manage/AdminLogin";
import AdminDashboard from "./manage/AdminDashboard";
import AdminAddCourse from "./manage/AdminAddCourse";
import AdminViewCourse from "./manage/AdminViewCourse";
import AdminEditCourse from "./manage/AdminEditCourse";
import AdminAddStudent from "./manage/AdminAddStudent";
import AdminViewStudent from "./manage/AdminViewStudent";
import AdminEditStudent from "./manage/AdminEditStudent";
import AdminStudentAllocation from "./manage/AdminStudentAllocation";
import AdminFeesManager from "./manage/AdminFeesManager";
import AdminAccreditations from "./manage/AdminAccreditations";
import AdminAwards from "./manage/AdminAwards";
import AdminBlogs from "./manage/AdminBlogs"; // New: Combined add and manage blogs
import AdminEditBlog from "./manage/AdminEditBlog"; // New: Edit blog
import AdminAddBatch from "./manage/AdminAddBatch";
import AdminViewBatches from "./manage/AdminViewBatches";
import AdminEditBatch from "./manage/AdminEditBatch";
import AdminBatchLessons from "./manage/AdminBatchLessons";
import AdminBatchStudents from "./manage/AdminBatchStudents"; 
import AdminAddLesson from "./manage/AdminAddLesson";
import AdminViewLessons from "./manage/AdminViewLessons";
import AdminProfile from "./manage/AdminProfile";
import AdminEditLesson from "./manage/AdminEditLesson";
import AdminAddBooks from "./manage/AdminAddBooks";
import AdminViewPdf from "./manage/AdminViewPdf";
import AdminSetBatchDates from "./manage/AdminSetBatchDates";
import AdminQuotation from "./manage/AdminQuotation";
import AdminTestimonials from "./manage/AdminTestimonials";
import AdminInfrastructure from "./manage/AdminInfrastructure";
import AdminPressMedia from "./manage/AdminPressMedia";
import AdminEditPressMedia from "./manage/AdminEditPressMedia";
import AdminCoursePages from "./manage/AdminCoursePages";
import AdminCoursePageEditor from "./manage/AdminCoursePageEditor";
import AdminAboutPages from "./manage/AdminAboutPages";
import AdminAboutPageEditor from "./manage/AdminAboutPageEditor";
import AdminHomeBanners from "./manage/AdminHomeBanners";
import AdminHomeBadges from "./manage/AdminHomeBadges";
import AdminHomeHighlights from "./manage/AdminHomeHighlights";
import AdminHomeFeaturedCourses from "./manage/AdminHomeFeaturedCourses";
import AdminHomeCounters from "./manage/AdminHomeCounters";
import AdminHomeContent from "./manage/AdminHomeContent";
import AdminMailSettings from "./manage/AdminMailSettings";
import AdminContactPage from "./manage/AdminContactPage";
import AdminAttendanceQR from "./manage/AdminAttendanceQR";
import AdminAttendanceReport from "./manage/AdminAttendanceReport";
import AdminMockExamBanks from "./manage/AdminMockExamBanks";
import AdminMockExamBankPreview from "./manage/AdminMockExamBankPreview";
import AdminMockExamQuestions from "./manage/AdminMockExamQuestions";
import AdminMockExams from "./manage/AdminMockExams";
import AdminMockExamForm from "./manage/AdminMockExamForm";
import AdminMockExamAttempts from "./manage/AdminMockExamAttempts";
import AdminMockExamAttemptDetail from "./manage/AdminMockExamAttemptDetail";
import AdminMockExamReports from "./manage/AdminMockExamReports";
import AdminAssignments from "./manage/AdminAssignments";
import AdminAssignmentForm from "./manage/AdminAssignmentForm";
import AdminAssignmentSubmissions from "./manage/AdminAssignmentSubmissions";
import AdminAssignmentSubmissionPdf from "./manage/AdminAssignmentSubmissionPdf";
import AdminCertificates from "./manage/AdminCertificates";
import AdminCertificateForm from "./manage/AdminCertificateForm";
import AdminCertificateManager from "./manage/AdminCertificateManager";
import AdminRegistrations from "./manage/AdminRegistrations";
import AdminPhotoGallery from "./manage/AdminPhotoGallery";
import AdminVideoGallery from "./manage/AdminVideoGallery";
import AdminCaseStudies from "./manage/AdminCaseStudies";
import AdminViewCaseStudy from "./manage/AdminViewCaseStudy";

import Login from "./students/Login";
import Dashboard from "./students/Dashboard";
import Courses from "./students/Courses";
import CourseDetails from "./students/CourseDetails";
import Fees from  "./students/Fees"
import StudentProfile from "./students/StudentProfile";
import StudentResources from "./students/StudentResources";
import StudentViewPdf from "./students/StudentViewPdf";
import StudentMyAttendance from "./students/StudentMyAttendance";
import MarkAttendance from "./students/MarkAttendance";
import MockExamList from "./students/MockExamList";
import MockExamInstructions from "./students/MockExamInstructions";
import MockExamTake from "./students/MockExamTake";
import MockExamResult from "./students/MockExamResult";
import MockExamHistory from "./students/MockExamHistory";
import StudentAssignments from "./students/StudentAssignments";
import StudentAssignmentDetail from "./students/StudentAssignmentDetail";
import StudentAssignmentSubmissionPdf from "./students/StudentAssignmentSubmissionPdf";
import StudentCaseStudies from "./students/StudentCaseStudies";
import StudentViewCaseStudy from "./students/StudentViewCaseStudy";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
         <Route path="/manage" element={<AdminLogin />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/admin-add-course" element={<AdminAddCourse />} />
        <Route path="/admin-view-course" element={<AdminViewCourse />} />
        <Route path="/admin-edit-course/:id" element={<AdminEditCourse />} />
        <Route path="/admin-add-student" element={<AdminAddStudent />} />
        <Route path="/admin-view-students" element={<AdminViewStudent />} /> {/* Corrected to plural for consistency */}
        <Route path="/admin-edit-student/:id" element={<AdminEditStudent />} />
        <Route path="/admin-student-allocation" element={<AdminStudentAllocation />} />
        <Route path="/admin-fees-manager" element={<AdminFeesManager />} />
        <Route path="/admin-accreditations" element={<AdminAccreditations />} />
        <Route path="/admin-awards" element={<AdminAwards />} />
        <Route path="/admin-blogs" element={<AdminBlogs />} /> {/* New route */}
        <Route path="/admin-edit-blog/:id" element={<AdminEditBlog />} /> {/* New route */}
        <Route path="/admin-add-batch" element={<AdminAddBatch />} />
        <Route path="/admin-view-batches" element={<AdminViewBatches />} />
        <Route path="/admin-edit-batch/:id" element={<AdminEditBatch />} />
        <Route path="/admin-batch-lessons/:batchid" element={<AdminBatchLessons />} />
        <Route path="/admin-batch-students/:batchid" element={<AdminBatchStudents />} />
        <Route path="/admin-add-lesson/:batchid" element={<AdminAddLesson />} />
        <Route path="/admin-view-lessons/:batchid" element={<AdminViewLessons />} />
        <Route path="/admin-profile" element={<AdminProfile />} />
        <Route path="/admin-edit-lesson/:id" element={<AdminEditLesson />} />
        <Route path="/admin-add-books" element={<AdminAddBooks />} />
        <Route path="/admin-view-pdf" element={<AdminViewPdf />} />
        <Route path="/admin-set-batch-dates/:batchId" element={<AdminSetBatchDates />} />
        <Route path="/admin-attendance-qr" element={<AdminAttendanceQR />} />
        <Route path="/admin-attendance-report" element={<AdminAttendanceReport />} />
        <Route path="/admin-mock-exam-banks" element={<AdminMockExamBanks />} />
        <Route path="/admin-mock-exam-bank-preview/:bankId" element={<AdminMockExamBankPreview />} />
        <Route path="/admin-mock-exam-questions/:bankId" element={<AdminMockExamQuestions />} />
        <Route path="/admin-mock-exams" element={<AdminMockExams />} />
        <Route path="/admin-mock-exam-form" element={<AdminMockExamForm />} />
        <Route path="/admin-mock-exam-form/:id" element={<AdminMockExamForm />} />
        <Route path="/admin-mock-exam-attempts/:examId" element={<AdminMockExamAttempts />} />
        <Route path="/admin-mock-exam-attempt/:attemptId" element={<AdminMockExamAttemptDetail />} />
        <Route path="/admin-mock-exam-reports" element={<AdminMockExamReports />} />
        <Route path="/admin-assignments" element={<AdminAssignments />} />
        <Route path="/admin-assignment-form" element={<AdminAssignmentForm />} />
        <Route path="/admin-assignment-form/:id" element={<AdminAssignmentForm />} />
        <Route path="/admin-assignment-submissions/:id" element={<AdminAssignmentSubmissions />} />
        <Route path="/admin-assignment-submission-pdf" element={<AdminAssignmentSubmissionPdf />} />
        <Route path="/admin-certificates" element={<AdminCertificates />} />
        <Route path="/admin-certificate-manager" element={<AdminCertificateManager />} />
        <Route path="/admin-registrations" element={<AdminRegistrations />} />
        <Route path="/admin-certificate-form" element={<AdminCertificateForm />} />
        <Route path="/admin-certificate-form/:id" element={<AdminCertificateForm />} />
        <Route path="/admin-photo-gallery" element={<AdminPhotoGallery />} />
        <Route path="/admin-video-gallery" element={<AdminVideoGallery />} />
        <Route path="/admin-case-studies" element={<AdminCaseStudies />} />
        <Route path="/admin-view-case-study" element={<AdminViewCaseStudy />} />
        <Route path="/admin-quotation" element={<AdminQuotation />} />
        <Route path="/admin-testimonials" element={<AdminTestimonials />} />
        {/* <Route path="/admin-testimonials" element={<AdminTestimonials />} /> */}
        <Route path="/admin-infrastructure" element={<AdminInfrastructure />} />
        <Route path="/admin-press-media" element={<AdminPressMedia />} />
        <Route path="/admin-edit-press-media/:id" element={<AdminEditPressMedia />} />
        <Route path="/admin-course-pages" element={<AdminCoursePages />} />
        <Route path="/admin-course-pages/new" element={<AdminCoursePageEditor />} />
        <Route path="/admin-course-pages/edit/:id" element={<AdminCoursePageEditor />} />
        <Route path="/admin-about-pages" element={<AdminAboutPages />} />
        <Route path="/admin-about-pages/new" element={<AdminAboutPageEditor />} />
        <Route path="/admin-about-pages/edit/:id" element={<AdminAboutPageEditor />} />
        <Route path="/admin-contact-page" element={<AdminContactPage />} />
        <Route path="/admin-home-banners" element={<AdminHomeBanners />} />
        <Route path="/admin-home-badges" element={<AdminHomeBadges />} />
        <Route path="/admin-home-highlights" element={<AdminHomeHighlights />} />
        <Route path="/admin-home-featured-courses" element={<AdminHomeFeaturedCourses />} />
        <Route path="/admin-home-counters" element={<AdminHomeCounters />} />
        <Route path="/admin-home-content" element={<AdminHomeContent />} />
        <Route path="/admin-mail-settings" element={<AdminMailSettings />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/course-details/:batchid" element={<CourseDetails />} />
        <Route path="/fees" element={<Fees />} />
        <Route path="/profile" element={<StudentProfile />} />
        <Route path="/student-resources" element={<StudentResources />} />
        <Route path="/student-view-pdf" element={<StudentViewPdf />} />
        <Route path="/student-my-attendance" element={<StudentMyAttendance />} />
        <Route path="/mark-attendance" element={<MarkAttendance />} />
        <Route path="/mock-exams" element={<MockExamList />} />
        <Route path="/mock-exam-instructions/:examId" element={<MockExamInstructions />} />
        <Route path="/mock-exam-take/:attemptId" element={<MockExamTake />} />
        <Route path="/mock-exam-result/:attemptId" element={<MockExamResult />} />
        <Route path="/mock-exam-history" element={<MockExamHistory />} />
        <Route path="/assignments" element={<StudentAssignments />} />
        <Route path="/assignments/:id" element={<StudentAssignmentDetail />} />
        <Route path="/assignment-submission-pdf" element={<StudentAssignmentSubmissionPdf />} />
        <Route path="/student-case-studies" element={<StudentCaseStudies />} />
        <Route path="/student-view-case-study" element={<StudentViewCaseStudy />} />



      </Routes>
    </BrowserRouter>
  );
};

export default App;
